export enum TagGroupValidationErrorType {
  TagGroupNameConflict = 0,
  TagNameConflict = 1,
  UsedTagsCannotBeDeleted = 2
}
